// Codici "misura" che in realtà sono valori DERIVATI, non misure corporee:
// vengono calcolati automaticamente da computeGarment (Tg = C.T./2, ecc.).
// Non vanno chiesti all'utente né conteggiati come "misura mancante".

const DERIVED_NORMALIZED = new Set([
  'tg',
  'size',
  'taglia',
  'vest',
  'vestibilita',
  'vestibilità',
])

// Stessa normalizzazione di formula.ts: minuscolo, niente punto finale
function normalize(code: string): string {
  return code.replace(/\.$/, '').toLowerCase().trim()
}

export function isDerivedCode(code: string): boolean {
  return DERIVED_NORMALIZED.has(normalize(code))
}

// Filtra via i codici derivati da una lista di misure richieste
export function bodyMeasurementsOnly(codes: string[]): string[] {
  return codes.filter(c => !isDerivedCode(c))
}
